// extracted by mini-css-extract-plugin
export var acitonButtons = "_mc-0";
export var additionalIcon = "_mc-f";
export var block = "_mc-1";
export var blockContent = "_mc-7";
export var blockDescription = "_mc-8";
export var blockIcon = "_mc-9";
export var blockTitle = "_mc-6";
export var border = "_mc-a";
export var center = "_mc-l";
export var edge = "_mc-b";
export var edgeLabel = "_mc-c";
export var edgePath = "_mc-d";
export var error = "_mc-e";
export var flowchart = "_mc-g";
export var flowchartContent = "_mc-h";
export var highlighted = "_mc-3";
export var hover = "_mc-4";
export var icon = "_mc-i";
export var left = "_mc-m";
export var navButton = "_mc-j";
export var navButtons = "_mc-k";
export var right = "_mc-n";
export var selected = "_mc-2";
export var small = "_mc-5";